const SESSION_ID_KEY = 'medhug_session_id';
const TAB_OPENED_AT_KEY = 'medhug_tab_opened_at';

function canUseSessionStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

function randomFallbackId() {
  return `mh_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

function generateSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return randomFallbackId();
}

export function getOrCreateSessionId() {
  if (!canUseSessionStorage()) {
    return generateSessionId();
  }

  const existing = window.sessionStorage.getItem(SESSION_ID_KEY);
  if (existing) {
    return existing;
  }

  const created = generateSessionId();
  window.sessionStorage.setItem(SESSION_ID_KEY, created);
  return created;
}

export function getOrCreateTabOpenedAt() {
  if (!canUseSessionStorage()) {
    return new Date().toISOString();
  }

  const existing = window.sessionStorage.getItem(TAB_OPENED_AT_KEY);
  if (existing) {
    return existing;
  }

  const created = new Date().toISOString();
  window.sessionStorage.setItem(TAB_OPENED_AT_KEY, created);
  return created;
}

export function getSessionMeta() {
  return {
    sessionId: getOrCreateSessionId(),
    tabOpenedAt: getOrCreateTabOpenedAt(),
  };
}
